export const NODE_ENV = process.env.NODE_ENV;
export const API_URL = process.env.REACT_APP_API
export const LOCIZE_PROJECT_ID = process.env.REACT_APP_LOCIZE_PROJECT_ID;
export const LOCIZE_API_KEY = process.env.REACT_APP_LOCIZE_API_KEY;
export const IS_PRODUCTION = process.env.REACT_APP_IS_PRODUCTION === "true";
export const WS_URL = process.env.REACT_APP_WS_API;
